function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import React from "react";
// @ts-ignore
import BrowserSymbol from "svg-baker-runtime/browser-symbol";
import { IconSettingsContext } from "./IconSettings";
import { addSpriteSymbol, useIsomorphicLayoutEffect } from "./sprite";
import { warnOnce } from "./warnOnce";
var svgStyle = {
    display: "block"
};
function iconClass(fragments, param) {
    var classPrefix = param.classPrefix, globalClasses = param.globalClasses;
    var res = "";
    for(var i = 0; i < fragments.length; i++){
        if (classPrefix) {
            res += " " + (classPrefix + fragments[i]);
        }
        if (!classPrefix || globalClasses) {
            res += " " + fragments[i];
        }
    }
    return res;
}
var SvgIcon = function(_param) {
    var width = _param.width, height = _param.height, viewBox = _param.viewBox, id = _param.id, _className = _param.className, className = _className === void 0 ? "" : _className, _style = _param.style, style = _style === void 0 ? {} : _style, fill = _param.fill, getRootRef = _param.getRootRef, _Component = _param.Component, Component = _Component === void 0 ? "div" : _Component, role = _param.role, ariaLabel = _param["aria-label"], ariaHidden = _param["aria-hidden"], restProps = _objectWithoutProperties(_param, [
        "width",
        "height",
        "viewBox",
        "id",
        "className",
        "style",
        "fill",
        "getRootRef",
        "Component",
        "role",
        "aria-label",
        "aria-hidden"
    ]);
    var size = Math.max(width, height);
    var iconSettings = React.useContext(IconSettingsContext);
    var ownClass = iconClass([
        "Icon",
        "Icon--".concat(size),
        "Icon--w-".concat(width),
        "Icon--h-".concat(height),
        "Icon--".concat(id)
    ], iconSettings);
    return /*#__PURE__*/ React.createElement(Component, _extends({
        role: "presentation"
    }, restProps, {
        ref: getRootRef,
        className: "".concat(ownClass, " ").concat(className),
        style: _objectSpreadProps(_objectSpread({}, style), {
            width: width,
            height: height
        })
    }), /*#__PURE__*/ React.createElement("svg", {
        viewBox: viewBox,
        width: width,
        height: height,
        style: svgStyle,
        role: role,
        "aria-label": ariaLabel,
        "aria-hidden": ariaHidden
    }, /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#".concat(id),
        style: {
            fill: "currentColor",
            color: fill
        }
    })));
};
export function makeIcon(componentName, id, viewBox, content, width, height, deprecated, replacement) {
    var isMounted = false;
    function mountIcon() {
        if (!isMounted) {
            addSpriteSymbol(new BrowserSymbol({
                id: id,
                viewBox: viewBox,
                content: content
            }));
            isMounted = true;
        }
    }
    var warn = deprecated ? warnOnce(componentName) : null;
    var Icon = function(props) {
        useIsomorphicLayoutEffect(mountIcon, []);
        if (deprecated) {
            var replacementNotice = replacement ? ". \u0417\u0430\u043C\u0435\u043D\u0438\u0442\u0435 \u043D\u0430 ".concat(replacement) : "";
            warn("\u0418\u043A\u043E\u043D\u043A\u0430 \u0443\u0441\u0442\u0430\u0440\u0435\u043B\u0430" + replacementNotice);
        }
        return /*#__PURE__*/ React.createElement(SvgIcon, _extends({}, props, {
            viewBox: viewBox,
            id: id,
            width: !isNaN(props.width) ? +props.width : width,
            height: !isNaN(props.height) ? +props.height : height
        }));
    };
    Icon.mountIcon = mountIcon;
    Icon.displayName = componentName;
    return Icon;
}
